module.exports = __webpack_public_path__ + "static/img/ic_certificate_f.97832b63.png";